export default __webpack_public_path__ + "images/downloadCSV.d873f92817099531f05662a343b7b9eb.svg";